import {
	Flex,
	IconV2,
	LayoutBox,
	Nub,
	StyledBoxV2,
	TextButton,
	TextField,
} from '@bamboohr/fabric';
import { isEnabled } from '@utils/feature';
import { ReactElement, useState } from 'react';

export function LoginPassword({
	showForgotPassword = true,
	inputId = 'password',
}): ReactElement {
	const [passwordType, setPasswordType] = useState('password');
	const [passwordText, setPasswordText] = useState($.__('Show Password'));

	const updatePasswordType = () => {
		setPasswordType(passwordType === 'password' ? 'text' : 'password');
		setPasswordText(
			passwordText === $.__('Show Password')
				? $.__('Hide Password')
				: $.__('Show Password'),
		);
	};

	// TODO: Remove this with the PASSKEYS toggle cleanup
	let tabIndex: number | undefined;
	if (!isEnabled('PASSKEYS')) {
		if (window.location.pathname.includes('self_onboarding')) {
			tabIndex = 0;
		} else {
			tabIndex = 4;
		}
	}

	return (
		<LayoutBox marginBottom={showForgotPassword ? 4 : ''}>
			<div className="fab-InputWrapper">
				<TextField
					InputProps={{
						startAdornment: (
							<Nub position="start">
								<IconV2 name="key-regular" size={16} />
							</Nub>
						),
					}}
					aria-label={$.__('Password')}
					data-placeholder-trigger="keydown"
					id={inputId}
					inputProps={{
						tabIndex,
						type: passwordType,
					}}
					name="password"
					placeholder={$.__('Password')}
					width={9}
				/>
			</div>
			<StyledBoxV2 marginTop={0.5}>
				<Flex
					alignItems="center"
					justifyContent={showForgotPassword ? 'space-between' : 'flex-end'}
				>
					{showForgotPassword && (
						<button
							className="fab-TextButton fab-TextButton--muted fab-TextButton--small ffront forgot"
							type="button"
						>
							{$.__('Forgot Password?')}
						</button>
					)}
					<TextButton
						color="secondary"
						onClick={updatePasswordType}
						size="small"
						type="button"
					>
						{passwordText}
					</TextButton>
				</Flex>
			</StyledBoxV2>
		</LayoutBox>
	);
}
export default LoginPassword;
